import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3edc3ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "style" }
const _hoisted_2 = {
  key: 0,
  class: "optionsBox"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "登陆 Gitee-码云", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "about" }, "登陆来同步您的数据配置", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "operation" }, null, -1))
const _hoisted_6 = { class: "btns" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("前往授权")
const _hoisted_8 = {
  key: 1,
  class: "optionsBox"
}
const _hoisted_9 = { class: "title" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "about" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "operation" }, [
  /*#__PURE__*/_createElementVNode("p", null, " 我们会创建一个名为「IceCreamSearchData」的仓库用来存储您的数据 "),
  /*#__PURE__*/_createElementVNode("p", null, "改完任何设置记得来这里上传数据哦！")
], -1))
const _hoisted_13 = { class: "btns" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("创建仓库")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("上传数据")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("获取数据")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("注销")

import config from "@/config/config";
import data from "@/data/data";
import giteeUtil from "@/utils/giteeUtil";

/**
 * 打开授权页面
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'me',
  setup(__props) {

function openAuthorization() {
    window.location.href = `https://gitee.com/oauth/authorize?client_id=${config.gitee.clientId}&redirect_uri=${config.gitee.redirectUri}&response_type=code&scope=${config.gitee.scope}`;
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(data).saveData.gitee.giteeName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: openAuthorization
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, "欢迎您！" + _toDisplayString(_unref(data).saveData.gitee.giteeName), 1),
          _createElementVNode("img", {
            class: "avatar",
            src: _unref(data).saveData.gitee.giteeAvatar,
            alt: _unref(data).saveData.gitee.giteeName
          }, null, 8, _hoisted_10),
          _hoisted_11,
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _unref(giteeUtil).checkRepos
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _unref(giteeUtil).pushDataToGitee
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _unref(giteeUtil).pullDataToGitee
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _unref(giteeUtil).logout
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]))
  ]))
}
}

})